import React from 'react';
import './WinnerStripItem.css';
import { useDispatch } from 'react-redux';
import { useTranslations } from '../../../../../shared/src/hooks/use-translations.hook';
import { Image } from '../../../../../shared/src/components/Image';
import {
    GtmEventLocation,
    GtmEventComponent,
    GtmEventClickElement
} from '../../../../../shared/src/components/google-tag-manager/enums/gtm-event-enum';
import { GtmService } from '../../../../../shared/src/services/gtm.service';
import { useCurrentVerticalData } from '../../../../../shared/src/hooks/use-current-vertical-data.hook';

export const WinnersStripItem = ({
    winner,
    playNowHandler,
}) => {
    const amount = `${winner.currencySymbol}${parseInt(winner.winAmount, 10)}`;
    const dispatch = useDispatch();
    const { t } = useTranslations();

    const cmsWinnerImage = winner.game.images.mainThumbnailImage ?? winner.game.images.default;
    const images = {
        default: winner.game.isCmsGame ? cmsWinnerImage : winner.game.images.default,
        webp: winner.game.isCmsGame ? cmsWinnerImage : winner.game.images.webp
    };
    const {
        pamGameVerticalID,
        currentVerticalType,
    } = useCurrentVerticalData();

    const openGame = () => {
        GtmService.track({
            location: GtmEventLocation.GAME_GRID,
            component: GtmEventComponent.WINNER_TICKER,
            click_element: GtmEventClickElement.IMG,
            click_action: 'open demo game',
            game_id: winner.game.id,
            game_vertical_id: pamGameVerticalID,
            game_vertical_type: currentVerticalType,
        });
        dispatch(playNowHandler({
            gameId: winner.game.id,
        }));
    };

    return <div className="winner-strip-item" onClick={openGame}>
        <div className="winner-strip-item__image-wrap">
            <Image
                images={images}
                className="winner-strip-item__image"
                loadingIcon="winner"
                alt={winner.game.name}
            />
        </div>
        <div className="winner-strip-item__text-wrap">
            <div className="winner-strip-item__player-name">{winner.playerName}</div>
            <div className="winner-strip-item__subtitle">{t('won')}</div>
            <div className="winner-strip-item__amount">{amount}</div>
        </div>
    </div>;
};
